import { render } from "./updatepassword.vue?vue&type=template&id=49e793d8&scoped=true"
import script from "./updatepassword.vue?vue&type=script&lang=js"
export * from "./updatepassword.vue?vue&type=script&lang=js"

import "./updatepassword.vue?vue&type=style&index=0&id=49e793d8&scoped=true&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e793d8"]])

export default __exports__